<template>
  <div>
    <ProductForm />
  </div>
</template>

<script>
import ProductForm from '@/components/Product/Form'

export default {
  name: 'CreateProduct',
  components: { ProductForm },
}
</script>